import { CountryIso3166, RiskScore } from "@tfg/db"
import { z } from "zod"

import { sortValueSchema } from "@tfg/types/schemas/traceabilityRequests"
import { standardEmail, stringToJSONSchema } from "@tfg/types/schemas/utils"

import { ContactRequests } from "../../endpoints/contacts"
import { CountryIso3166Schema, LanguageIso6391Schema } from "../enum"

import { hasAliasOrTypeId } from "./utils"

export const MappingTypesEnum = z.enum(["PRODUCT", "MATERIAL", "STANDARD"])
export const typeMappingUpdateSchema = z
  .object({
    alias: z.string(),
    typeId: z.number(),
    type: MappingTypesEnum,
  })
  .refine((data) => hasAliasOrTypeId(data.alias, data.typeId), {
    message: "At least one of alias or productTypeId must be provided.",
  })
export type typeMappingUpdateValidationType = z.infer<
  typeof typeMappingUpdateSchema
>

export const SupplierTypeSchema = z.enum([
  "all",
  "direct",
  "indirect",
  "indirectConfidential",
])

export type SupplierTypeValidationType = z.infer<typeof SupplierTypeSchema>

export const orderBySchema = z
  .object({
    name: sortValueSchema,
    company: sortValueSchema,
    pendingProductrequests: sortValueSchema,
    // pendingTransactionCertificaterequests: sortValueSchema,
    // pendingScopeCertificaterequests: sortValueSchema,
    pendingProductionSiterequests: sortValueSchema,
    completedProductrequests: sortValueSchema,
    // completedTransactionCertificaterequests: sortValueSchema,
    // completedScopeCertificaterequests: sortValueSchema,
    completedProductionSiterequests: sortValueSchema,
    email: sortValueSchema,
    averageResponseTime: sortValueSchema,
    lastConnectionDate: sortValueSchema,
    lastReminderDate: sortValueSchema,
    // ratio: sortValueSchema,
  })
  .partial()

export type orderByValidationType = z.infer<typeof orderBySchema>
export const supplierMonitoringFiltersSchema = z.object({
  supplierType: SupplierTypeSchema.optional(),
  searchSupplier: z.string().optional(),
  country: z.nativeEnum(CountryIso3166).optional(),
})
export type supplierMonitoringFiltersValidationType = z.infer<
  typeof supplierMonitoringFiltersSchema
>

export const supplierRiskFiltersSchema = z.object({
  riskCertification: z.nativeEnum(RiskScore).optional(),
  riskCollaboration: z.nativeEnum(RiskScore).optional(),
})

export type supplierRiskFiltersValidationType = z.infer<
  typeof supplierRiskFiltersSchema
>

export const productionSitesQuerySchema = z.object({
  skip: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  searchProductionSite: z.string().optional(),
})

export type productionSitesQueryValidationType = z.infer<
  typeof productionSitesQuerySchema
>

export const riskQuerySchema = z.object({
  skip: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  filters: stringToJSONSchema.pipe(supplierRiskFiltersSchema).optional(),
  searchSupplier: z.string().optional(),
})

export type riskQueryValidationType = z.infer<typeof riskQuerySchema>

export const paramsIdSchema = z.object({
  userId: z.string().uuid(),
})

export const transferContactSchema = z.object({
  email: standardEmail(),
  name: z.string(),
  organizationName: z.string(),
  organizationCountry: CountryIso3166Schema,
  language: LanguageIso6391Schema,
  oldContactUserId: z.string().uuid(),
}) satisfies z.ZodType<ContactRequests.TransferContact>

export type transferContactValidationType = z.infer<
  typeof transferContactSchema
>

export const SupplierGetQuerySchema = z.object({
  skip: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  filters: z
    .string()
    .transform(stringToJSONSchema.parse)
    .pipe(supplierMonitoringFiltersSchema)
    .optional(),
  searchSupplier: z.string().optional(),
  orderBy: z
    .string()
    .transform(stringToJSONSchema.parse)
    .pipe(orderBySchema)
    .optional(),
})

export type SupplierGetQueryValidationType = z.infer<
  typeof SupplierGetQuerySchema
>
